<template>
<header class="header header--checkout container container--fluid">
  <div class="u-d-flex u-justify-content-space-between">
    <div class="header__h1">
      <a href="https://www.enchantchristmas.com" target="_target">
        <svg class="header__logo" alt="Enchant" width="966px" height="966px" viewBox="0 0 966 966" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Enchant</title>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="e-mark">
              <g id="close" transform="translate(255.000000, 276.000000)" stroke="#E8C592" stroke-linecap="square" stroke-width="30" style="opacity: 0;">
                <path d="M0.810082036,0.016088311 L456,455.206006" id="Line"></path>
                <path d="M0.810082036,0.016088311 L456,455.206006" id="Line-Copy" transform="translate(228.000000, 228.000000) rotate(-90.000000) translate(-228.000000, -228.000000) "></path>
              </g>
              <path id="logo" d="M482.62,0 C216.5,0 0,216.5 0,482.62 C0,748.74 216.5,965.24 482.62,965.24 C748.74,965.24 965.24,748.74 965.24,482.62 C965.24,216.5 748.74,0 482.62,0 Z M482.62,918.99 C242.01,918.99 46.25,723.24 46.25,482.62 C46.25,242 242,46.25 482.62,46.25 C723.24,46.25 918.99,242 918.99,482.62 C918.99,723.24 723.24,918.99 482.62,918.99 Z M657.57,601.72 C654.42,630.46 643.85,662.3 617.46,674.12 C604.92,679.74 590.71,679.85 576.97,679.86 C536.23,679.9 495.5,679.95 454.76,680 C454.76,617.85 454.77,555.69 454.78,493.54 L454.78,494.08 L499.76,494.08 C499.76,494.08 526.32,493.22 538.52,500.46 C550.72,507.7 559.34,522.58 555.44,536.22 C558.33,536.27 561.21,536.33 564.1,536.38 C564.09,502.68 564.07,468.97 564.06,435.27 C561.18,435.34 558.3,435.4 555.42,435.47 C559.3,449.12 550.7,463.97 538.52,471.27 C524.16,479.87 497.27,478.29 497.27,478.29 L454.77,478.29 C454.76,420.01 454.76,361.73 454.75,303.45 C492.15,303.51 529.56,303.58 566.96,303.64 C580.39,303.66 594.24,303.77 606.57,309.09 C633.38,320.65 644.58,352.7 647.65,381.73 C652.13,381.7 656.62,381.67 661.1,381.63 C661.09,346.66 661.09,311.68 661.08,276.71 C575.02,276.48 488.95,276.25 402.89,276.02 C334.86,275.84 249.98,281.57 222.46,356.52 C203.22,408.89 226.78,466.1 277.22,489.77 C309.52,504.93 355.08,505.26 383.81,481.87 C384.36,481.55 392.89,473.2 394.31,471.55 C394.32,512.9 394.34,554.25 394.35,595.6 C394.36,614.52 394.25,634.03 386.94,651.48 C376.57,676.23 351.24,693.98 324.44,695.27 C324.48,699.26 324.52,703.26 324.56,707.25 C440.03,707.25 555.5,707.24 670.97,707.24 C670.97,672.11 670.97,636.98 670.97,601.85 C666.52,601.8 662.04,601.76 657.57,601.72 Z M391.88,450.46 C389.21,456.58 386.64,460.65 375.33,470.23 C355.09,487.38 321.16,482.37 298.7,472.74 C280.92,465.12 265.42,451.33 257.87,433.52 C240.74,393.11 261.72,342.31 297.28,319.38 C320.01,304.72 345.61,303.37 371.84,303.5 L373.22,303.5 C375.15,303.53 376.87,303.53 378.27,303.5 C383.6,303.39 388.94,303.5 394.27,303.5 C394.28,350.74 394.3,397.98 394.31,445.22 C393.34,447.17 392.51,449.04 391.88,450.46 Z" fill="#E8C592" fill-rule="nonzero"></path>
            </g>
          </g>
        </svg>
      </a>
    </div>

    <button class="burger" aria-label="Open menu" @click="openMenu">
        <span class="u-sr">Open menu</span>
        <div class="burger__bar burger__bar--top"></div>
        <div class="burger__bar burger__bar--middle"></div>
        <div class="burger__bar burger__bar--bottom"></div>
    </button>
  </div>
</header>
</template>

<script>
export default {
    name: 'CheckoutHeader',
    methods: {
        openMenu() {
          let x = document.getElementsByTagName("BODY")[0];
          x.classList.add('has-open-menu');
          this.$store.dispatch('menu/setMenuOpen', true);
        }
    }
}
</script>

<style>

</style>
